  ////售后状态
  export const refundstatus= [{
        value: 0,
        label:'暂无售后',
        lang:'views.modules.order.order.refundStatus_o'
      },
      {
        value: 1,
        label:'退款申请中',
        lang:'views.modules.order.order.refundStatus1'
      },
      {
        value: 2,
        label:'退款成功',
        color:'#ff0000',
        lang:'views.modules.order.order.refundStatus2'
      },
      {
        value: 3,
        label:'部分退款成功',
        lang:'views.modules.order.order.refundStatus3'
      },
      {
        value: 4,
        label:'退款失败',
        color:'#ff0000',
        lang:'views.modules.order.order.refundStatus4'
      }]

////订单状态
export const billstatus=[{
        value: 1,
        label:'待付款',
        lang:'views.modules.order.order.status1'
      },
      {
        value: 2,
        label:'待发货',
        lang:'views.modules.order.order.status2'
      },
      {
        value: 3,
        label:'待收货',
        lang:'views.modules.order.order.status3'
      },
      {
        value: 4,
        label:'待评价',
        lang:'views.modules.order.order.status4'
      },
      {
        value: 5,
        label:'交易成功',
        lang:'views.modules.order.order.status5'
      },
      {
        value: 6,
        label:'交易失败',
        lang:'views.modules.order.order.status6'
      },{
        value: 7,
        label:'待成团',
        lang:'views.modules.order.order.status7'
      },
      {
        value: 8,
        label:'通关失败',
        lang:'views.modules.order.order.status8'
      },
      {
        value: 9,
        label:'通关中',
        lang:'views.modules.order.order.status9'
      }]

  ////  发货仓
  export const fiampWarehouse=[
  {
    value:1,
    label:'Fiamp自营仓',
    lang:'wareHouseType.FIAMP'
  },
  {
    value:0,
    label:'其它',
    lang:'views.modules.prod.prodInfoNew.province13'
  }
  ]

export const ioType=[
  {
    value:0,
    label:'支出',
    lang:'srcCrud.shop.wallet.iotype0'
  },
  {
    value:1,
    label:'收入',
    lang:'srcCrud.shop.wallet.iotype1'
  }
]

export const settleStatus=[
  {
    value:1,
    color:'#7E7AF6',
    label:'已结算',
    lang:'srcCrud.market.distProd.ss2'
  },
  {
    value:2,
    color:'#FFAF20',
    label:'受理中',
    lang:'finance.accepting'
  },
  {
    value:3,
    color:'#ff0000',
    label:'未通过',
    lang:'sell.auditStatus1'
  }
]


export const saleCurrency=[
 {
    value:'CN',
    label:'中国',
    priceCurrency:'CNY'
  },
  {
    value:'SG',
    label:'新加坡',
    priceCurrency:'USD'
  },{
    value:'MY',
    label:'马来西亚',
    priceCurrency:'MYR'
  },{
    value:'KR',
    label:'韩国',
    priceCurrency:'KRW'
  },{
    value:'JP',
    label:'日本',
    priceCurrency:'JPY'
  },{
    value:'HK',
    label:'中国香港',
    priceCurrency:'HKY'
  },{
    value:'WW',
    label:'全球',
    priceCurrency:'USD'
  }
]


export const isSettled=[
      {
        value: 0,
        label: '未结算',
        color:'#CE2200',
        lang:'srcCrud.market.distProd.ss1'},
      {
        value: 1,
        label: '已结算',
        color:'#7E7AF6',
        lang:'srcCrud.market.distProd.ss2'}
        ]
  ////订单来源

  export const retailType=[
   {
    value:0,
    label:'小程序',
    lang:'srcCrud.admin.indexImg.platform0'
  },
  {
    value:1,
    label:'抖音',
    lang:'sell.BCCDouyin'
  },
  {
    value:2,
    label:'淘分销',
    lang:'sell.BBCTaobao'
  },
  {
    value:3,
    label:'独立站',
    lang:'sell.BBCFiamp'
  },
  {
    value:4,
    label:'全球购',
    lang:'exts.taobao'
  }
  ]


export const qudaoNames=[
  {value:0,label:'小程序',lang:'saleCountry.sysUserIdName2'},
  {value:1,label:'抖音',lang:'saleCountry.sysUserIdName20'},
  {value:2,label:'鲸芽',lang:'saleCountry.sysUserIdName74'},
  {value:3,label:'Fiamp',lang:'saleCountry.sysUserIdName3'},
  {value:4,label:'全球购',lang:'saleCountry.sysUserIdName75'},
  {value:5,label:'京东',lang:'saleCountry.sysUserIdName76'},
  {value:6,label:'小红书',lang:'views.modules.prod.brand.xiaohongshu'},
  {value:7,label:'快手',lang:'views.modules.prod.brand.kuaishou'},
  {value:8,label:'TikTok',lang:'saleCountry.TikTok'},
  {value:9,label:'SHOPLINE',lang:'saleCountry.SHOPLINE'},
  {value:10,label:'拼多多',lang:'saleCountry.sysUserIdName78'}
  ]
  
//////结算状态 0 待审核，1 已审核， 2 已处理,  3 审核失败
export const fueStatus=[
  {
    value:'0',
    label:'待审核',
    lang:'srcCrud.market.distProd.ss1'
  },
  {
    value:'1',
    color:'#7E7AF6',
    label:'已审核',
    lang:'views.modules.prod.sku.approve1'
  },
  {
    value:'2',
    color:'#7E7AF6',
    label:'已处理',
    lang:''
  },
  {
    value:'3',
    label:'审核失败',
    color:'#ff0000',
    lang:'srcCrud.admin.fetch.status4'
  }
  ]


export const opaAuditStatus=[
  {
    value:'-1',
    label:'未提交',
    lang:''
  },
  {
    value:'0',
    label:'待审核',
    lang:'srcCrud.market.distProd.ss1'
  },
  {
    value:'1',
    color:'#7E7AF6',
    label:'已审核',
    lang:'views.modules.prod.sku.approve1'
  },
  {
    value:'2',
    label:'审核失败',
    color:'#ff0000',
    lang:'srcCrud.admin.fetch.status4'
  }
  ]

export const opaAuditStatusb=[
  {
    value:'-1',
    label:'未提交',
    lang:''
  },
  {
    value:'0',
    label:'待审核',
    lang:'srcCrud.market.distProd.ss1'
  },
  {
    value:'1',
    color:'#7E7AF6',
    label:'支付成功',
    lang:'views.modules.prod.sku.approve1'
  },
  {
    value:'2',
    label:'支付失败',
    color:'#ff0000',
    lang:'srcCrud.admin.fetch.status4'
  },
  {
    value:'3',
    label:'支付异常',
    color:'#CFAF00',
    lang:'srcCrud.admin.fetch.status4'
  }
  ]

export const sysUserIdToCurrency=[
  {
    value:'4',
    label:'美元'
  },
  {
    value:'77',
    label:'美元'
  }
]
/////Invoice生成状态.   0未生成, 1已生成

export const fueInvoiceStatus=[
  {
    value:0,
    label:'未生成',
    lang:''
  },
  {
    value:1,
    label:'已生成',
    lang:''
  }
]

// 月度仓储费处理状态：  0 暂存， 1 已提交， 2 已处理

export const sfStatus=[
  {
    value:'0',
    color:'#ff0000',
    label:'暂存',
    lang:''
  },
  {
    value:'1',
    color:'#000000',
    label:'已提交',
    lang:''
  },
  {
    value:'2',
    color:'#7E7AF6',
    label:'已处理',
    lang:''
  }
]

export const countryList=[
    {value:'CN',label:'中国',lang:'views.modules.shop.bank.CN'},
    {value:'KR',label:'韩国',lang:'views.modules.shop.bank.KR'},
    {value:'IT',label:'意大利',lang:'views.modules.shop.bank.IT'},
    {value:'JP',label:'日本',lang:'views.modules.shop.bank.JP'},
    {value:'HK',label:'中国香港',lang:'views.modules.shop.bank.HK'},
    {value:'SG',label:'新加坡',lang:'views.modules.shop.bank.SG'},
    {value:'US',label:'美国',lang:'views.modules.shop.bank.SG'}
  ]

  export const countryNames=[
    {id:'CN',name:'中国'},
    {id:'KR',name:'韩国'},
    {id:'IT',name:'意大利'},
    {id:'JP',name:'日本'},
    {id:'HK',name:'中国香港'},
    {id:'SG',name:'新加坡'},
    {id:'US',name:'美国'}
  ]

export const qudaoStatus=[
  {
    value:0,
    label:'禁用',
    lang:''
  },
  {
    value:1,
    label:'正常',
    lang:''
  }
]

//可以开通的销售国家
export const saleCountry=[
 {
    value:'CN',
    label:'中国',
  },
  {
    value:'SG',
    label:'新加坡'
  }
]
export function getQudaoFromRetailType(retailType)
{
  var  qudaolist=[
  {value:0,label:'小程序'},
  {value:1, label:'抖音'},
  {value:2,label:'鲸芽'},
  {value:3, label:'Fiamp'},
  {value:4,label:'全球购'},
  {value:5,label:'京东'},
  {value:6,label:'小红书'},
  {value:7,label:'快手'},
  {value:8,label:'抖音海外版'},
  {value:9,label:'SHOPLINE'},
  {value:10,label:'拼多多'},
  {value:11,label:'得物'},
  {value:12,label:'Shopee'},
  {value:13,label:'PitchPop'},
  {value:14,label:'SHOPIFY'}
  ]
  for(var it of qudaolist)
    if(it.value==retailType) return it.label;
  return '';
}

export function getStatusName(it)
{
  if(it.auditType==1 && it.auditStatus == 0) return '未上架';
  if(it.auditType==1 && it.auditStatus == 2) return '未上架';
  if(it.auditType==1 && it.auditStatus == 1) return '已上架';
  if(it.auditType==2 && it.auditStatus == 0) return '已上架';
  if(it.auditType==2 && it.auditStatus == 1) return '已上架';
  if(it.auditType==2 && it.auditStatus == 2) return '已上架';
  if(it.auditType==3 && it.auditStatus == 1) return '已上架';
  if(it.auditType==4 && it.auditStatus == 0) return '已上架';
  if(it.auditType==4 && it.auditStatus == 2) return '已上架';
  if(it.auditType==3 && it.auditStatus == 0) return '已下架';
  if(it.auditType==3 && it.auditStatus == 2) return '已下架';
  if(it.auditType==4 && it.auditStatus == 1) return '已下架';
  return '';
}

export function getStatusAudit(it)
{
  var typeName="重新上架";
  var typeStatus="待审核";
  if(it.auditType==1 || it.auditType==null)  typeName="首次上架";
  if(it.auditType==2) typeName="修改数据";
  if(it.auditType==3) typeName="重新上架";
  if(it.auditType==4) typeName="下架";       
  if(it.auditStatus==1) typeStatus="审核通过";
  if(it.auditStatus==2) typeStatus="审核失败";
  return typeName+'('+typeStatus+')';
}

//收单货币
export const payCurrency=[
 {
    value:'CNY',
    label:'人民币',
  },
  {
    value:'USD',
    label:'美元'
  },
  {
    value:'SGD',
    label:'新加坡元'
  }
]



export function getCurrencyName(Currency)
 {
  for(var it of payCurrency)
    if(it.value==Currency) return it.label;
  return '';
 }
 export function getCountryName(code)
 {
  for(var it of saleCountry)
    if(it.value==code)  return it.label;
  return '';
 }
//清关方式
export const clearType=[
    {
      value: 0,
      label:'备货BBC',
      lang:'views.modules.prod.filing.clearType0'},
    {
      value: 1,
      label:'备货BC',
      lang:'views.modules.prod.filing.clearType1'},
    {
      value: 2,
      label:'集货BC',
      lang:'views.modules.prod.filing.clearType2'},
    {
      value: 3,
      label: '集货CC',
      lang:'views.modules.prod.filing.clearType3'},
    {
      value: 4,
      label:'个人直邮CC',
      lang:'views.modules.prod.filing.clearType4'},
    {
      value: 5,
      label: '一般贸易',
      lang:'views.modules.prod.filing.clearType5'}
  ]

  ///whBusType 销售渠道（ 0 微信小程序/独立站、1 抖音、2 天猫）

  export const whBusType=[
      {
        value: 0,
        label: '菜鸟',
        lang:'views.modules.prod.filing.whBusWeChat'},
      {
        value: 1,
        label: '抖音',
        lang:'views.modules.prod.filing.whBusDouYin'}, 
      {
        value: 2,
        label: '天猫',
        lang:'views.modules.prod.filing.whBusTMall'}  
    ]
    
    export const qudaoFeeNames=[{
        value: 0,
        label:'用户支付',
        lang: 'srcCrud.shop.wallet.reason0'
      }, {
        value: 1,
        label:'用户确认收货',
        lang: 'srcCrud.shop.wallet.reason1'
      }, {
        value: 2,
        label:'用户进行退款',
        lang: 'srcCrud.shop.wallet.reason2'
      }
      ,{
        value: 4,
        label:'提现申请',
        lang: 'srcCrud.shop.wallet.reason4'
      }
      ,{
        value: 5,
        label:'提现申请被拒绝',
        lang: 'srcCrud.shop.wallet.reason5'
      }
      ,{
        value: 6,
        label:'提现申请通过',
        lang: 'srcCrud.shop.wallet.reason6'
      },{
        value: 9,
        label:'扣除分销收单费',
        lang: 'srcCrud.shop.wallet.reason9'
      },{
        value: 10,
        label:'扣除分销关税',
        lang: 'srcCrud.shop.wallet.reason10'
      },{
        value: 11,
        label:'保税仓退回分销关税',
        lang: 'srcCrud.shop.wallet.reason11'
      },{
        value: 20,
        label:'平台业务结算',
        lang: 'srcCrud.shop.wallet.reason20'
      },{
        value: 40,
        label:'订单结算',
        lang: 'srcCrud.shop.wallet.reason40'
      },{
        value: 41,
        label:'余额充值',
        lang: 'srcCrud.shop.wallet.reason41'
      },{
        value: 50,
        label:'余额支付',
        lang: 'srcCrud.shop.wallet.reason50'
      },{
        value: 51,
        label:'余额退款',
        lang: 'srcCrud.shop.wallet.reason51'
      }]

export const feeNames=[{
        value: 0,
        label:'用户支付',
        lang: 'srcCrud.shop.wallet.reason0'
      }, {
        value: 1,
        label:'用户确认收货',
        lang: 'srcCrud.shop.wallet.reason1'
      }, {
        value: 2,
        label:'用户退款申请',
        lang: 'srcCrud.shop.wallet.reason2'
      }
      ,{
        value: 4,
        label:'提现申请',
        lang: 'srcCrud.shop.wallet.reason4'
      }
      ,{
        value: 5,
        label:'提现申请被拒绝',
        lang: 'srcCrud.shop.wallet.reason5'
      }
      ,{
        value: 6,
        label:'提现申请通过',
        lang: 'srcCrud.shop.wallet.reason6'
      },{
        value: 7,
        label:'发放成功',
        lang: 'srcCrud.shop.wallet.reason7'
      },{
        value: 8,
        label:'发放失败',
        lang: 'srcCrud.shop.wallet.reason8'
      },{
        value: 9,
        label:'扣除订单分销金额',
        lang: 'srcCrud.shop.wallet.reason9'
      },{
        value: 10,
        label:'扣除关税/运费/通关费',
        lang: 'srcCrud.shop.wallet.reason10'
      },{
        value: 11,
        label:'扣除收单手续费',
        lang: 'srcCrud.shop.wallet.reason11'
      },{
        value: 12,
        label:'扣除退款手续费',
        lang: 'srcCrud.shop.wallet.reason12'
      },{
        value: 13,
        label:'渠道结算',
        lang: 'srcCrud.shop.wallet.reason13'
      },{
        value: 14,
        label:'保税仓退回关税',
        lang: 'srcCrud.shop.wallet.reason14'
      },{
        value: 15,
        label:'保税仓回仓手续费',
        lang: 'srcCrud.shop.wallet.reason15'
      },{
        value: 20,
        label:'平台业务结算',
        lang: 'srcCrud.shop.wallet.reason20'
      },{
        value: 31,
        label:'扣除零售渠道平台服务费',
        lang: 'srcCrud.shop.wallet.reason31'
      },{
        value: 32,
        label:'扣除零售渠道带货佣金',
        lang: 'srcCrud.shop.wallet.reason32'
      },{
        value: 33,
        label:'退回零售渠道平台服务费',
        lang: 'srcCrud.shop.wallet.reason33'
      },{
        value: 34,
        label:'退回零售渠道带货佣金',
        lang: 'srcCrud.shop.wallet.reason34'
      },{
        value: 40,
        label:'订单结算',
        lang: 'srcCrud.shop.wallet.reason40'
      },{
        value: 50,
        label:'SKU备案费用',
        lang: 'srcCrud.shop.wallet.reason50'
      },{
        value: 51,
        label:'仓储费用',
        lang: 'srcCrud.shop.wallet.reason51'
      },{
        value: 52,
        label:'履行费用',
        lang: 'srcCrud.shop.wallet.reason52'
      },{
        value: 60,
        label:'商家服务订阅费',
        lang: 'srcCrud.shop.wallet.reason60'
      }
      ]